import { useCallback, useEffect, useMemo, useState } from 'react';
import './App.css';

const API_BASE = process.env.REACT_APP_API_BASE
  || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:8080/api'
    : '/api');

const LANGS = ['de', 'en', 'ru'];

const DICT = {
  de: {
    navSearch: 'Suche',
    navWipes: 'Wipes',
    navCompare: 'Vergleich',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Finde den perfekten Rust-Server.',
    heroCopy: 'Suche nach Wipe, Teamlimit, Rates, Region, Ping, Modded/Vanilla, Aktivitaet und Datenqualitaet.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Suchen',
    all: 'Alle',
    servers: 'Server',
    playersOnline: 'Spieler online',
    justWiped: 'Gerade gewiped',
    verifiedServers: 'Verifizierte Daten',
    liveServers: 'Live Server',
    topServers: 'Top Server',
    bestDuo: 'Beste Duo Server',
    bestVanilla: 'Beste Vanilla Server',
    upcomingWipes: 'Upcoming Wipes',
    verified: 'Verifiziert',
    officialTag: 'Offizieller Tag',
    nameDetected: 'Aus Name erkannt',
    historyEstimated: 'Historisch geschaetzt',
    uncertain: 'Unsicher',
    source: 'Quelle',
    confidence: 'Sicherheit',
    quickFilters: 'Quick Filter',
    advancedFilters: 'Erweiterte Filter',
    region: 'Region',
    type: 'Typ',
    team: 'Team',
    gather: 'Gather',
    wipe: 'Wipe',
    quality: 'Qualitaet',
    population: 'Population',
    sort: 'Ranking',
    lowPing: 'Low Ping',
    highPop: 'High Pop',
    noBp: 'No BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Spieler',
    ping: 'Ping',
    nextWipe: 'Naechster Wipe',
    lastWipe: 'Letzter Wipe',
    map: 'Map',
    mapSize: 'Map Size',
    bpWipe: 'BP-Wipe',
    dataQuality: 'Datenqualitaet',
    connect: 'Connect',
    copyIp: 'Copy IP',
    details: 'Details',
    compare: 'Vergleichen',
    alert: 'Alert',
    favorite: 'Favorit',
    remove: 'Entfernen',
    empty: 'Keine passenden Server gefunden.',
    quietError: 'Daten werden gerade aktualisiert. Bitte gleich erneut versuchen.',
    profile: 'Serverprofil',
    overview: 'Ueberblick',
    history: 'Historie',
    rules: 'Rules',
    fullName: 'Vollstaendiger Name',
    endpoint: 'IP und Port',
    status: 'Status',
    mode: 'Modus',
    ownerStatus: 'Owner Status',
    notClaimed: 'Nicht geclaimt',
    snapshots: 'Spieler 24h',
    wipeHistory: 'Wipe-Historie',
    noHistory: 'Noch keine Historie vorhanden.',
    close: 'Schliessen',
    compareServers: 'Server vergleichen',
    compareHint: 'Waehle 2 bis 4 Server aus.',
    createAlert: 'Alert erstellen',
    alertCopy: 'Wir merken uns diesen Suchwunsch im Browser. Backend-Benachrichtigungen koennen spaeter E-Mail, Discord oder Telegram senden.',
    saveAlert: 'Alert speichern',
    savedAlert: 'Alert gespeichert',
    copied: 'Kopiert',
    connectCopied: 'Connect-Befehl kopiert',
    recommended: 'Empfohlen',
    ranking: 'Rust Radar Score',
    noBpWipe: 'Kein BP-Wipe',
    yes: 'Ja',
    no: 'Nein',
    unknown: 'Unbekannt',
    online: 'Online',
    offline: 'Offline',
    today: 'Heute',
    tomorrow: 'Morgen',
    seoTitle: 'Beliebte Rust-Suchen',
    footerCopy: 'Jede Information bekommt eine Quelle. Jede Schaetzung bekommt einen Confidence Score.',
  },
  en: {
    navSearch: 'Search',
    navWipes: 'Wipes',
    navCompare: 'Compare',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Find the perfect Rust server.',
    heroCopy: 'Search by wipe, team limit, rates, region, ping, modded/vanilla, activity and data quality.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Search',
    all: 'All',
    servers: 'Servers',
    playersOnline: 'Players online',
    justWiped: 'Just wiped',
    verifiedServers: 'Verified data',
    liveServers: 'Live servers',
    topServers: 'Top servers',
    bestDuo: 'Best duo servers',
    bestVanilla: 'Best vanilla servers',
    upcomingWipes: 'Upcoming wipes',
    verified: 'Verified',
    officialTag: 'Official tag',
    nameDetected: 'Detected from name',
    historyEstimated: 'History estimate',
    uncertain: 'Uncertain',
    source: 'Source',
    confidence: 'Confidence',
    quickFilters: 'Quick filters',
    advancedFilters: 'Advanced filters',
    region: 'Region',
    type: 'Type',
    team: 'Team',
    gather: 'Gather',
    wipe: 'Wipe',
    quality: 'Quality',
    population: 'Population',
    sort: 'Ranking',
    lowPing: 'Low ping',
    highPop: 'High pop',
    noBp: 'No BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Players',
    ping: 'Ping',
    nextWipe: 'Next wipe',
    lastWipe: 'Last wipe',
    map: 'Map',
    mapSize: 'Map size',
    bpWipe: 'BP wipe',
    dataQuality: 'Data quality',
    connect: 'Connect',
    copyIp: 'Copy IP',
    details: 'Details',
    compare: 'Compare',
    alert: 'Alert',
    favorite: 'Favorite',
    remove: 'Remove',
    empty: 'No matching servers found.',
    quietError: 'Data is being refreshed. Please try again shortly.',
    profile: 'Server profile',
    overview: 'Overview',
    history: 'History',
    rules: 'Rules',
    fullName: 'Full name',
    endpoint: 'IP and port',
    status: 'Status',
    mode: 'Mode',
    ownerStatus: 'Owner status',
    notClaimed: 'Not claimed',
    snapshots: 'Players 24h',
    wipeHistory: 'Wipe history',
    noHistory: 'No history yet.',
    close: 'Close',
    compareServers: 'Compare servers',
    compareHint: 'Select 2 to 4 servers.',
    createAlert: 'Create alert',
    alertCopy: 'This search is stored in your browser. Backend notifications can later send email, Discord or Telegram.',
    saveAlert: 'Save alert',
    savedAlert: 'Alert saved',
    copied: 'Copied',
    connectCopied: 'Connect command copied',
    recommended: 'Recommended',
    ranking: 'Rust Radar score',
    noBpWipe: 'No BP wipe',
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown',
    online: 'Online',
    offline: 'Offline',
    today: 'Today',
    tomorrow: 'Tomorrow',
    seoTitle: 'Popular Rust searches',
    footerCopy: 'Every fact gets a source. Every estimate gets a confidence score.',
  },
  ru: {
    navSearch: 'Поиск',
    navWipes: 'Вайпы',
    navCompare: 'Сравнение',
    heroEyebrow: 'Rust Server Intelligence',
    heroTitle: 'Найди идеальный Rust-сервер.',
    heroCopy: 'Поиск по вайпу, лимиту команды, рейтам, региону, пингу, модам, активности и качеству данных.',
    searchPlaceholder: 'eu duo 2x wiped today',
    searchButton: 'Искать',
    all: 'Все',
    servers: 'Серверы',
    playersOnline: 'Игроков онлайн',
    justWiped: 'Недавний вайп',
    verifiedServers: 'Проверенные данные',
    liveServers: 'Live серверы',
    topServers: 'Топ серверы',
    bestDuo: 'Лучшие Duo',
    bestVanilla: 'Лучшие Vanilla',
    upcomingWipes: 'Скоро вайп',
    verified: 'Проверено',
    officialTag: 'Официальный тег',
    nameDetected: 'Из названия',
    historyEstimated: 'Оценка по истории',
    uncertain: 'Неуверенно',
    source: 'Источник',
    confidence: 'Уверенность',
    quickFilters: 'Быстрые фильтры',
    advancedFilters: 'Фильтры',
    region: 'Регион',
    type: 'Тип',
    team: 'Команда',
    gather: 'Рейт',
    wipe: 'Вайп',
    quality: 'Качество',
    population: 'Онлайн',
    sort: 'Рейтинг',
    lowPing: 'Низкий пинг',
    highPop: 'Высокий онлайн',
    noBp: 'Без BP',
    monthly: 'Monthly',
    vanilla: 'Vanilla',
    modded: 'Modded',
    pve: 'PvE',
    official: 'Official',
    community: 'Community',
    premium: 'Premium',
    players: 'Игроки',
    ping: 'Пинг',
    nextWipe: 'Следующий вайп',
    lastWipe: 'Последний вайп',
    map: 'Карта',
    mapSize: 'Размер карты',
    bpWipe: 'BP вайп',
    dataQuality: 'Качество данных',
    connect: 'Connect',
    copyIp: 'Copy IP',
    details: 'Детали',
    compare: 'Сравнить',
    alert: 'Alert',
    favorite: 'Избранное',
    remove: 'Удалить',
    empty: 'Подходящих серверов нет.',
    quietError: 'Данные обновляются. Попробуй еще раз чуть позже.',
    profile: 'Профиль сервера',
    overview: 'Обзор',
    history: 'История',
    rules: 'Rules',
    fullName: 'Полное название',
    endpoint: 'IP и порт',
    status: 'Статус',
    mode: 'Режим',
    ownerStatus: 'Owner status',
    notClaimed: 'Не подтвержден',
    snapshots: 'Игроки 24ч',
    wipeHistory: 'История вайпов',
    noHistory: 'Истории пока нет.',
    close: 'Закрыть',
    compareServers: 'Сравнить серверы',
    compareHint: 'Выбери от 2 до 4 серверов.',
    createAlert: 'Создать alert',
    alertCopy: 'Этот поиск сохранится в браузере. Позже backend сможет отправлять email, Discord или Telegram.',
    saveAlert: 'Сохранить alert',
    savedAlert: 'Alert сохранен',
    copied: 'Скопировано',
    connectCopied: 'Connect команда скопирована',
    recommended: 'Рекомендуем',
    ranking: 'Rust Radar score',
    noBpWipe: 'Без вайпа чертежей',
    yes: 'Да',
    no: 'Нет',
    unknown: 'Неизвестно',
    online: 'Онлайн',
    offline: 'Оффлайн',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    seoTitle: 'Популярные поиски Rust',
    footerCopy: 'У каждой информации есть источник. У каждой оценки есть confidence score.',
  }
};

const defaultFilters = {
  query: '',
  mode: 'all',
  region: 'all',
  gather: 'all',
  group: 'all',
  wipe: 'all',
  minPlayers: 0,
  sort: 'confidence',
  onlineOnly: true,
  quality: 'all',
  population: 'all',
  bp: 'all',
  lowPing: false
};

const quickFilters = [
  { id: 'just-wiped', label: 'Just Wiped', patch: { wipe: 'all', sort: 'wipe' }, local: { justWiped: true } },
  { id: 'eu', label: 'EU', patch: { region: 'EU' } },
  { id: 'solo', label: 'Solo', patch: { group: 'solo' } },
  { id: 'duo', label: 'Duo', patch: { group: 'duo' } },
  { id: 'trio', label: 'Trio', patch: { group: 'trio' } },
  { id: '2x', label: '2x', patch: { gather: '2x' } },
  { id: 'vanilla', label: 'Vanilla', patch: { mode: 'vanilla' } },
  { id: 'monthly', label: 'Monthly', patch: { wipe: 'monthly' } },
  { id: 'no-bp', label: 'No BP', patch: { bp: 'no' } },
  { id: 'pve', label: 'PvE', patch: { mode: 'pve' } },
  { id: 'low-ping', label: 'Low Ping', patch: { lowPing: true } }
];

const landingPages = [
  { path: '/de/rust-duo-server', label: 'Beste Rust Duo Server', patch: { group: 'duo' } },
  { path: '/en/rust-duo-servers', label: 'Best Rust Duo Servers', patch: { group: 'duo' } },
  { path: '/ru/rust-duo-серверы', label: 'Rust Duo серверы', patch: { group: 'duo' } },
  { path: '/de/rust-server-gerade-gewiped', label: 'Rust Server gerade gewiped', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/en/rust-servers-just-wiped', label: 'Rust servers just wiped', patch: { sort: 'wipe' }, local: { justWiped: true } },
  { path: '/de/rust-2x-server', label: 'Rust 2x Server', patch: { gather: '2x' } },
  { path: '/de/deutsche-rust-server', label: 'Deutsche Rust Server', patch: { region: 'EU', query: 'german deutsch' } },
  { path: '/en/rust-vanilla-servers', label: 'Rust Vanilla Servers', patch: { mode: 'vanilla' } },
  { path: '/en/rust-no-bp-wipe-servers', label: 'No BP Wipe Servers', patch: { bp: 'no' } }
];

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem('rustRadarLang') || detectLanguage());
  const [smartQuery, setSmartQuery] = useState('');
  const [filters, setFilters] = useState(defaultFilters);
  const [localFlags, setLocalFlags] = useState({});
  const [servers, setServers] = useState([]);
  const [stats, setStats] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [softError, setSoftError] = useState(false);
  const [selected, setSelected] = useState(null);
  const [snapshots, setSnapshots] = useState([]);
  const [wipes, setWipes] = useState([]);
  const [toast, setToast] = useState('');
  const [compareIds, setCompareIds] = useState(() => readJson('rustRadarCompare', []));
  const [favoriteIds, setFavoriteIds] = useState(() => readJson('rustRadarFavorites', []));
  const [alertOpen, setAlertOpen] = useState(false);
  const [compareOpen, setCompareOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const t = DICT[lang] || DICT.de;

  useEffect(() => {
    localStorage.setItem('rustRadarLang', lang);
  }, [lang]);

  useEffect(() => {
    const match = landingPages.find((pageItem) => pageItem.path === window.location.pathname);
    if (match) {
      setFilters((current) => ({ ...current, ...match.patch }));
      setLocalFlags(match.local || {});
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('rustRadarCompare', JSON.stringify(compareIds));
  }, [compareIds]);

  useEffect(() => {
    localStorage.setItem('rustRadarFavorites', JSON.stringify(favoriteIds));
  }, [favoriteIds]);

  const request = useCallback(async (path, options = {}) => {
    const response = await fetch(`${API_BASE}${path}`, options);
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `HTTP ${response.status}`);
    }
    return response.json();
  }, []);

  const queryString = useMemo(() => {
    const params = new URLSearchParams({
      page: String(page),
      size: '100',
      mode: filters.mode,
      region: filters.region,
      gather: filters.gather,
      group: filters.group,
      wipe: filters.wipe,
      sort: filters.sort === 'radar' ? 'confidence' : filters.sort,
      onlineOnly: String(filters.onlineOnly)
    });
    if (filters.query.trim()) params.set('query', filters.query.trim());
    if (Number(filters.minPlayers) > 0) params.set('minPlayers', String(filters.minPlayers));
    return params.toString();
  }, [filters, page]);

  const loadServers = useCallback(async () => {
    try {
      const data = await request(`/servers?${queryString}`);
      setServers(data.items || []);
      setTotal(data.total || 0);
      setSoftError(false);
    } catch {
      setSoftError(true);
      setServers([]);
      setTotal(0);
    }
  }, [queryString, request]);

  const loadStats = useCallback(async () => {
    try {
      setStats(await request('/stats'));
    } catch {
      setStats(null);
    }
  }, [request]);

  useEffect(() => {
    loadServers();
    const timer = window.setInterval(loadServers, 15000);
    return () => window.clearInterval(timer);
  }, [loadServers]);

  useEffect(() => {
    loadStats();
    const timer = window.setInterval(loadStats, 30000);
    return () => window.clearInterval(timer);
  }, [loadStats]);

  const enrichedServers = useMemo(() => {
    return servers
      .map((server) => enrichServer(server))
      .filter((server) => applyLocalFilters(server, filters, localFlags))
      .sort((a, b) => sortLocal(a, b, filters.sort));
  }, [servers, filters, localFlags]);

  const heroStats = useMemo(() => {
    const onlinePlayers = enrichedServers.reduce((sum, server) => sum + (server.players || 0), 0);
    const justWiped = enrichedServers.filter((server) => server.isJustWiped).length;
    const verified = enrichedServers.filter((server) => server.dataQuality >= 85).length;
    return {
      totalServers: stats?.totalServers ?? total,
      onlinePlayers,
      justWiped,
      verified
    };
  }, [enrichedServers, stats, total]);

  const sections = useMemo(() => {
    const top = [...enrichedServers].sort((a, b) => b.radarScore - a.radarScore).slice(0, 6);
    const just = enrichedServers.filter((server) => server.isJustWiped).slice(0, 6);
    const duo = enrichedServers.filter((server) => server.groupLimitDetected === 'duo').slice(0, 6);
    const vanilla = enrichedServers.filter((server) => !server.moddedDetected).slice(0, 6);
    const upcoming = [...enrichedServers]
      .filter((server) => server.nextWipeEstimated)
      .sort((a, b) => new Date(a.nextWipeEstimated) - new Date(b.nextWipeEstimated))
      .slice(0, 6);
    return { top, just, duo, vanilla, upcoming };
  }, [enrichedServers]);

  const compareServers = useMemo(() => {
    return compareIds.map((id) => enrichedServers.find((server) => server.id === id)).filter(Boolean);
  }, [compareIds, enrichedServers]);

  const updateFilter = (key, value) => {
    setFilters((current) => ({ ...current, [key]: value }));
    setLocalFlags((current) => key === 'sort' ? current : { ...current, justWiped: false });
    setPage(0);
  };

  const resetFilters = () => {
    setFilters(defaultFilters);
    setLocalFlags({});
    setSmartQuery('');
    setPage(0);
  };

  const submitSmartSearch = (event) => {
    event.preventDefault();
    const parsed = parseSmartSearch(smartQuery);
    setFilters((current) => ({ ...current, ...parsed.filters, query: smartQuery.trim() }));
    setLocalFlags(parsed.local);
    setPage(0);
  };

  const applyQuickFilter = (chip) => {
    setFilters((current) => ({ ...current, ...chip.patch }));
    setLocalFlags(chip.local || {});
    setPage(0);
  };

  const openDetails = async (server) => {
    try {
      const [profile, history, wipeHistory] = await Promise.all([
        request(`/servers/${server.id}`),
        request(`/servers/${server.id}/snapshots`),
        request(`/servers/${server.id}/wipes`)
      ]);
      setSelected(enrichServer(profile));
      setSnapshots(history || []);
      setWipes(wipeHistory || []);
    } catch {
      setSelected(server);
      setSnapshots([]);
      setWipes([]);
    }
  };

  const copyText = async (value, message = t.copied) => {
    await navigator.clipboard?.writeText(value);
    setToast(message);
    window.setTimeout(() => setToast(''), 1600);
  };

  const toggleCompare = (server) => {
    setCompareIds((current) => {
      if (current.includes(server.id)) {
        return current.filter((id) => id !== server.id);
      }
      return [server.id, ...current].slice(0, 4);
    });
  };

  const toggleFavorite = (server) => {
    setFavoriteIds((current) => {
      if (current.includes(server.id)) {
        return current.filter((id) => id !== server.id);
      }
      return [server.id, ...current];
    });
  };

  const saveAlert = () => {
    const alerts = readJson('rustRadarAlerts', []);
    const next = [{ id: Date.now(), query: smartQuery, filters, createdAt: new Date().toISOString() }, ...alerts].slice(0, 20);
    localStorage.setItem('rustRadarAlerts', JSON.stringify(next));
    setAlertOpen(false);
    setToast(t.savedAlert);
  };

  const navigateLanding = (item) => {
    window.history.pushState({}, '', item.path);
    setFilters((current) => ({ ...current, ...item.patch }));
    setLocalFlags(item.local || {});
    setPage(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="productShell">
      <header className="siteHeader">
        <a className="brandLockup" href="/" onClick={(event) => { event.preventDefault(); resetFilters(); window.history.pushState({}, '', '/'); }}>
          <span className="brandGlyph">R</span>
          <span>
            <strong>Rust Radar</strong>
            <small>Server Intelligence</small>
          </span>
        </a>
        <nav className="topNav" aria-label="Main">
          <a href="#search">{t.navSearch}</a>
          <a href="#wipes">{t.navWipes}</a>
          <button type="button" onClick={() => setCompareOpen(true)}>{t.navCompare} <span>{compareIds.length}</span></button>
        </nav>
        <div className="languageSwitch" aria-label="Language">
          {LANGS.map((code) => (
            <button className={code === lang ? 'active' : ''} key={code} type="button" onClick={() => setLang(code)}>
              {code.toUpperCase()}
            </button>
          ))}
        </div>
      </header>

      <main>
        <section className="heroSection" id="search">
          <div className="heroContent">
            <p className="eyebrow">{t.heroEyebrow}</p>
            <h1>{t.heroTitle}</h1>
            <p className="heroCopy">{t.heroCopy}</p>
            <form className="smartSearch" onSubmit={submitSmartSearch}>
              <span className="searchIcon">⌕</span>
              <input value={smartQuery} onChange={(event) => setSmartQuery(event.target.value)} placeholder={t.searchPlaceholder} />
              <button type="submit">{t.searchButton}</button>
            </form>
            <div className="quickChips" aria-label={t.quickFilters}>
              {quickFilters.map((chip) => (
                <button key={chip.id} type="button" onClick={() => applyQuickFilter(chip)}>{chip.label}</button>
              ))}
            </div>
          </div>
          <div className="heroStats">
            <Metric value={heroStats.totalServers} label={t.liveServers} />
            <Metric value={heroStats.onlinePlayers} label={t.playersOnline} />
            <Metric value={heroStats.justWiped} label={t.justWiped} />
            <Metric value={heroStats.verified} label={t.verifiedServers} />
          </div>
        </section>

        <section className="filterDock">
          <div className="filterDockHeader">
            <div>
              <strong>{t.advancedFilters}</strong>
              <span>{formatNumber(enrichedServers.length)} / {formatNumber(total)} {t.servers}</span>
            </div>
            <div className="filterActions">
              <button type="button" onClick={() => setShowFilters((value) => !value)}>{showFilters ? t.close : t.advancedFilters}</button>
              <button type="button" onClick={resetFilters}>{t.all}</button>
            </div>
          </div>
          <div className={`filterGrid ${showFilters ? 'expanded' : ''}`}>
            <Select label={t.region} value={filters.region} onChange={(value) => updateFilter('region', value)} options={['all', 'EU', 'US', 'NA', 'AU', 'SEA', 'RU']} t={t} />
            <Select label={t.type} value={filters.mode} onChange={(value) => updateFilter('mode', value)} options={['all', 'vanilla', 'modded', 'official', 'pve']} t={t} />
            <Select label={t.team} value={filters.group} onChange={(value) => updateFilter('group', value)} options={['all', 'solo', 'duo', 'trio', 'quad', '5-max', '6-max', 'no-limit']} t={t} />
            <Select label={t.gather} value={filters.gather} onChange={(value) => updateFilter('gather', value)} options={['all', '1x', '1.5x', '2x', '3x', '5x', '10x', '50x', '100x']} t={t} />
            <Select label={t.wipe} value={filters.wipe} onChange={(value) => updateFilter('wipe', value)} options={['all', 'daily', 'weekly', 'biweekly', 'monthly']} t={t} />
            <Select label={t.quality} value={filters.quality} onChange={(value) => updateFilter('quality', value)} options={['all', 'verified', 'high', 'medium']} t={t} />
            <Select label={t.population} value={filters.population} onChange={(value) => updateFilter('population', value)} options={['all', 'high', 'medium', 'low']} t={t} />
            <Select label={t.bpWipe} value={filters.bp} onChange={(value) => updateFilter('bp', value)} options={['all', 'no', 'yes', 'unknown']} t={t} />
            <Select label={t.sort} value={filters.sort} onChange={(value) => updateFilter('sort', value)} options={['radar', 'players', 'wipe', 'fresh', 'confidence']} t={t} />
          </div>
        </section>

        {toast && <div className="toast">{toast}</div>}
        {softError && <div className="softNotice">{t.quietError}</div>}

        <section className="featureGrid" id="wipes">
          <FeaturePanel title={t.justWiped} servers={sections.just} empty={t.empty} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
          <FeaturePanel title={t.upcomingWipes} servers={sections.upcoming} empty={t.empty} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
        </section>

        <ServerSection
          title={t.topServers}
          subtitle={t.footerCopy}
          servers={enrichedServers.length ? enrichedServers : sections.top}
          t={t}
          compareIds={compareIds}
          favoriteIds={favoriteIds}
          onOpen={openDetails}
          onCopy={copyText}
          onCompare={toggleCompare}
          onFavorite={toggleFavorite}
          onAlert={(server) => { setSelected(server); setAlertOpen(true); }}
        />

        <section className="featureGrid">
          <FeaturePanel title={t.bestDuo} servers={sections.duo} empty={t.empty} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
          <FeaturePanel title={t.bestVanilla} servers={sections.vanilla} empty={t.empty} render={(server) => <MiniServer key={server.id} server={server} t={t} onOpen={openDetails} />} />
        </section>

        <section className="seoPanel">
          <div>
            <p className="eyebrow">{t.seoTitle}</p>
            <h2>Rust Server Finder</h2>
          </div>
          <div className="seoLinks">
            {landingPages.map((item) => (
              <button key={item.path} type="button" onClick={() => navigateLanding(item)}>{item.label}</button>
            ))}
          </div>
        </section>
      </main>

      {selected && !alertOpen && (
        <DetailDrawer
          server={selected}
          snapshots={snapshots}
          wipes={wipes}
          t={t}
          onClose={() => setSelected(null)}
          onCopy={copyText}
          onAlert={() => setAlertOpen(true)}
        />
      )}

      {compareOpen && (
        <CompareDrawer
          servers={compareServers}
          t={t}
          onClose={() => setCompareOpen(false)}
          onRemove={(server) => toggleCompare(server)}
        />
      )}

      {alertOpen && (
        <AlertDialog
          t={t}
          server={selected}
          filters={filters}
          query={smartQuery}
          onClose={() => setAlertOpen(false)}
          onSave={saveAlert}
        />
      )}
    </div>
  );
}

function ServerSection({ title, subtitle, servers, t, compareIds, favoriteIds, onOpen, onCopy, onCompare, onFavorite, onAlert }) {
  const visible = servers.slice(0, 18);
  return (
    <section className="serverSection">
      <div className="sectionHeader">
        <div>
          <p className="eyebrow">{t.recommended}</p>
          <h2>{title}</h2>
          <span>{subtitle}</span>
        </div>
      </div>
      {visible.length === 0 && <div className="emptyState">{t.empty}</div>}
      <div className="serverList">
        {visible.map((server) => (
          <ServerCard
            key={server.id}
            server={server}
            t={t}
            isCompared={compareIds.includes(server.id)}
            isFavorite={favoriteIds.includes(server.id)}
            onOpen={onOpen}
            onCopy={onCopy}
            onCompare={onCompare}
            onFavorite={onFavorite}
            onAlert={onAlert}
          />
        ))}
      </div>
    </section>
  );
}

function ServerCard({ server, t, isCompared, isFavorite, onOpen, onCopy, onCompare, onFavorite, onAlert }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const population = percentage(server.players, server.maxPlayers);
  const bp = detectBpWipe(server);
  return (
    <article className="serverCard">
      <div className="serverMain">
        <div className="titleRow">
          <h3 title={server.name || endpoint}>{server.name || endpoint}</h3>
          <button className={`starButton ${isFavorite ? 'active' : ''}`} type="button" onClick={() => onFavorite(server)} aria-label={t.favorite}>★</button>
        </div>
        <div className="serverMeta">
          <span>{endpoint}</span>
          <span>{server.region || t.unknown}</span>
          <span>{server.mapName || t.map}</span>
        </div>
        <div className="tagRow">
          <Badge text={server.online ? t.online : t.offline} tone={server.online ? 'green' : 'red'} />
          <Badge text={server.moddedDetected ? t.modded : t.vanilla} tone={server.moddedDetected ? 'orange' : 'green'} />
          {server.official && <Badge text={t.official} tone="blue" />}
          {server.groupLimitDetected && <Badge text={server.groupLimitDetected} tone="blue" />}
          {server.gatherRateDetected && <Badge text={server.gatherRateDetected} tone="orange" />}
          {server.wipeCycleDetected && <Badge text={server.wipeCycleDetected} tone="purple" />}
          <Badge text={`${t.dataQuality}: ${server.dataQuality}%`} tone={server.dataQuality >= 85 ? 'green' : server.dataQuality >= 65 ? 'yellow' : 'red'} />
        </div>
      </div>

      <div className="decisionGrid">
        <Info label={t.players} value={`${formatNumber(server.players)} / ${formatNumber(server.maxPlayers)}`} />
        <Info label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
        <Info label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} accent={server.isJustWiped} />
        <Info label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
        <Info label={t.team} value={server.groupLimitDetected || t.unknown} />
        <Info label={t.gather} value={server.gatherRateDetected || '1x'} />
        <Info label={t.bpWipe} value={bp.label(t)} />
        <Info label={t.mapSize} value={server.worldSize || t.unknown} />
      </div>

      <div className="scorePanel">
        <div className="scoreRing" style={{ '--score': `${server.radarScore}%` }}>
          <strong>{server.radarScore}</strong>
          <small>{t.ranking}</small>
        </div>
        <div className="popBar">
          <span style={{ width: `${population}%` }} />
        </div>
        <small>{t.source}: {sourceLabel(server, t)}</small>
      </div>

      <div className="cardActions">
        <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
        <button type="button" onClick={() => onCopy(endpoint, t.copied)}>{t.copyIp}</button>
        <button type="button" onClick={() => onOpen(server)}>{t.details}</button>
        <button className={isCompared ? 'activeAction' : ''} type="button" onClick={() => onCompare(server)}>{t.compare}</button>
        <button type="button" onClick={() => onAlert(server)}>{t.alert}</button>
      </div>
    </article>
  );
}

function DetailDrawer({ server, snapshots, wipes, t, onClose, onCopy, onAlert }) {
  const endpoint = `${server.ip}:${server.gamePort || server.queryPort}`;
  const rules = Object.entries(server.rules || {}).slice(0, 80);
  const bp = detectBpWipe(server);
  return (
    <aside className="drawerOverlay">
      <div className="detailDrawer">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.profile}</p>
            <h2>{server.name || endpoint}</h2>
            <span>{endpoint}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>

        <div className="drawerActions">
          <button className="connectButton" type="button" onClick={() => onCopy(`client.connect ${endpoint}`, t.connectCopied)}>{t.connect}</button>
          <button type="button" onClick={() => onCopy(endpoint, t.copied)}>{t.copyIp}</button>
          <button type="button" onClick={onAlert}>{t.alert}</button>
        </div>

        <div className="drawerBody">
          <section>
            <h3>{t.overview}</h3>
            <div className="kvGrid">
              <Kv label={t.fullName} value={server.name || '-'} />
              <Kv label={t.endpoint} value={endpoint} />
              <Kv label={t.status} value={server.online ? t.online : t.offline} />
              <Kv label={t.mode} value={server.official ? t.official : server.moddedDetected ? t.modded : t.vanilla} />
              <Kv label={t.players} value={`${formatNumber(server.players)} / ${formatNumber(server.maxPlayers)}`} />
              <Kv label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
              <Kv label={t.region} value={server.region || t.unknown} />
              <Kv label={t.team} value={server.groupLimitDetected || t.unknown} />
              <Kv label={t.gather} value={server.gatherRateDetected || '1x'} />
              <Kv label={t.bpWipe} value={bp.label(t)} />
              <Kv label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} />
              <Kv label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
              <Kv label={t.map} value={server.mapName || t.unknown} />
              <Kv label={t.mapSize} value={server.worldSize || t.unknown} />
              <Kv label={t.dataQuality} value={`${server.dataQuality}%`} />
              <Kv label={t.ownerStatus} value={t.notClaimed} />
            </div>
          </section>

          <section>
            <h3>{t.history}</h3>
            <HistoryBars snapshots={snapshots} t={t} />
          </section>

          <section>
            <h3>{t.wipeHistory}</h3>
            {wipes.length === 0 && <div className="emptyState compact">{t.noHistory}</div>}
            <div className="wipeList">
              {wipes.map((wipe) => (
                <Kv key={`${wipe.detectedAt}-${wipe.detectedBy}`} label={wipe.detectedBy || t.historyEstimated} value={`${wipe.type || t.unknown} · ${Math.round((wipe.confidence || 0) * 100)}% · ${formatDate(wipe.detectedAt, true) || '-'}`} />
              ))}
            </div>
          </section>

          <section>
            <h3>{t.rules}</h3>
            {rules.length === 0 && <div className="emptyState compact">{t.noHistory}</div>}
            {rules.length > 0 && (
              <table className="rulesTable">
                <tbody>
                  {rules.map(([key, value]) => <tr key={key}><td>{key}</td><td>{value}</td></tr>)}
                </tbody>
              </table>
            )}
          </section>
        </div>
      </div>
    </aside>
  );
}

function CompareDrawer({ servers, t, onClose, onRemove }) {
  return (
    <aside className="drawerOverlay">
      <div className="compareDrawer">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.navCompare}</p>
            <h2>{t.compareServers}</h2>
            <span>{t.compareHint}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>
        {servers.length === 0 && <div className="emptyState">{t.compareHint}</div>}
        {servers.length > 0 && (
          <div className="compareGrid">
            {servers.map((server) => (
              <div className="compareCard" key={server.id}>
                <button type="button" onClick={() => onRemove(server)}>{t.remove}</button>
                <h3>{server.name}</h3>
                <Kv label={t.players} value={`${formatNumber(server.players)} / ${formatNumber(server.maxPlayers)}`} />
                <Kv label={t.ping} value={server.pingMs ? `${server.pingMs} ms` : t.unknown} />
                <Kv label={t.lastWipe} value={formatRelative(server.lastWipeDetected, t)} />
                <Kv label={t.nextWipe} value={formatDate(server.nextWipeEstimated, true) || t.unknown} />
                <Kv label={t.team} value={server.groupLimitDetected || t.unknown} />
                <Kv label={t.gather} value={server.gatherRateDetected || '1x'} />
                <Kv label={t.dataQuality} value={`${server.dataQuality}%`} />
                <Kv label={t.ranking} value={server.radarScore} />
              </div>
            ))}
          </div>
        )}
      </div>
    </aside>
  );
}

function AlertDialog({ t, server, filters, query, onClose, onSave }) {
  return (
    <aside className="drawerOverlay">
      <div className="alertDialog">
        <div className="drawerHeader">
          <div>
            <p className="eyebrow">{t.alert}</p>
            <h2>{t.createAlert}</h2>
            <span>{server?.name || query || t.heroTitle}</span>
          </div>
          <button type="button" onClick={onClose}>{t.close}</button>
        </div>
        <p>{t.alertCopy}</p>
        <div className="kvGrid">
          <Kv label={t.region} value={filters.region} />
          <Kv label={t.team} value={filters.group} />
          <Kv label={t.gather} value={filters.gather} />
          <Kv label={t.wipe} value={filters.wipe} />
        </div>
        <button className="connectButton wide" type="button" onClick={onSave}>{t.saveAlert}</button>
      </div>
    </aside>
  );
}

function FeaturePanel({ title, servers, empty, render }) {
  return (
    <section className="featurePanel">
      <div className="panelHeader">
        <h2>{title}</h2>
      </div>
      {servers.length === 0 ? <div className="emptyState compact">{empty}</div> : <div className="miniList">{servers.map(render)}</div>}
    </section>
  );
}

function MiniServer({ server, t, onOpen }) {
  return (
    <button className="miniServer" type="button" onClick={() => onOpen(server)}>
      <span>
        <strong>{server.name}</strong>
        <small>{server.region || t.unknown} · {server.groupLimitDetected || t.team} · {server.gatherRateDetected || '1x'}</small>
      </span>
      <em>{formatNumber(server.players)}/{formatNumber(server.maxPlayers)}</em>
    </button>
  );
}

function HistoryBars({ snapshots, t }) {
  if (!snapshots.length) {
    return <div className="emptyState compact">{t.noHistory}</div>;
  }
  return (
    <div className="historyBars">
      {snapshots.slice(0, 24).map((snapshot) => (
        <div className="historyRow" key={snapshot.capturedAt}>
          <span>{formatDate(snapshot.capturedAt, true) || '-'}</span>
          <div className="bar"><i style={{ width: `${percentage(snapshot.players, snapshot.maxPlayers)}%` }} /></div>
          <strong>{snapshot.players || 0}/{snapshot.maxPlayers || 0}</strong>
        </div>
      ))}
    </div>
  );
}

function Select({ label, value, options, onChange, t }) {
  return (
    <label>
      <span>{label}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {options.map((option) => <option key={option} value={option}>{optionLabel(option, t)}</option>)}
      </select>
    </label>
  );
}

function Metric({ value, label }) {
  return (
    <div className="metricCard">
      <strong>{formatNumber(value)}</strong>
      <span>{label}</span>
    </div>
  );
}

function Info({ label, value, accent }) {
  return (
    <div className={`infoCell ${accent ? 'accent' : ''}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function Kv({ label, value }) {
  return <div className="kv"><span>{label}</span><strong>{String(value ?? '-')}</strong></div>;
}

function Badge({ text, tone }) {
  return <span className={`badge ${tone || ''}`}>{text}</span>;
}

function enrichServer(server) {
  const dataQuality = Math.round((server.confidenceScore || 0.45) * 100);
  const radarScore = calculateRadarScore(server, dataQuality);
  const lastWipe = server.lastWipeDetected ? new Date(server.lastWipeDetected) : null;
  const isJustWiped = lastWipe ? Date.now() - lastWipe.getTime() < 1000 * 60 * 60 * 24 : false;
  return {
    ...server,
    dataQuality,
    radarScore,
    isJustWiped
  };
}

function calculateRadarScore(server, dataQuality) {
  const pop = percentage(server.players, server.maxPlayers);
  const wipeBoost = server.lastWipeDetected ? Math.max(0, 20 - Math.floor((Date.now() - new Date(server.lastWipeDetected).getTime()) / 3600000)) : 0;
  const pingBoost = server.pingMs ? Math.max(0, 15 - Math.floor(server.pingMs / 20)) : 4;
  const verifiedBoost = dataQuality >= 85 ? 14 : dataQuality >= 65 ? 7 : 0;
  const onlineBoost = server.online ? 10 : 0;
  const score = Math.round((pop * 0.28) + wipeBoost + pingBoost + verifiedBoost + onlineBoost + (dataQuality * 0.28));
  return Math.max(1, Math.min(99, score));
}

function applyLocalFilters(server, filters, localFlags) {
  if (localFlags.justWiped && !server.isJustWiped) return false;
  if (filters.quality === 'verified' && server.dataQuality < 90) return false;
  if (filters.quality === 'high' && server.dataQuality < 75) return false;
  if (filters.quality === 'medium' && server.dataQuality < 55) return false;
  if (filters.population === 'high' && (server.players || 0) < 100) return false;
  if (filters.population === 'medium' && ((server.players || 0) < 30 || (server.players || 0) >= 100)) return false;
  if (filters.population === 'low' && (server.players || 0) >= 30) return false;
  if (filters.lowPing && (!server.pingMs || server.pingMs > 80)) return false;
  if (filters.bp !== 'all' && detectBpWipe(server).value !== filters.bp) return false;
  return true;
}

function sortLocal(a, b, sort) {
  if (sort === 'radar') return b.radarScore - a.radarScore;
  if (sort === 'players') return (b.players || 0) - (a.players || 0);
  if (sort === 'wipe') return dateValue(b.lastWipeDetected) - dateValue(a.lastWipeDetected);
  if (sort === 'fresh') return dateValue(b.lastSuccessfulQuery) - dateValue(a.lastSuccessfulQuery);
  if (sort === 'confidence') return b.dataQuality - a.dataQuality;
  return b.radarScore - a.radarScore;
}

function parseSmartSearch(query) {
  const value = query.toLowerCase();
  const filters = {};
  const local = {};

  if (/\beu\b/.test(value)) filters.region = 'EU';
  if (/\b(us|usa)\b/.test(value)) filters.region = 'US';
  if (/\b(na)\b/.test(value)) filters.region = 'NA';
  if (/\b(au)\b/.test(value)) filters.region = 'AU';
  if (/\b(ru|russian|рус|русский)\b/.test(value)) filters.region = 'RU';

  if (/\bsolo\b|соло/.test(value)) filters.group = 'solo';
  if (/\bduo\b|дуо/.test(value)) filters.group = 'duo';
  if (/\btrio\b|трио/.test(value)) filters.group = 'trio';
  if (/\bquad\b/.test(value)) filters.group = 'quad';

  const rate = value.match(/\b(1\.5|1,5|2|3|5|10|50|100)\s*x\b/);
  if (rate) filters.gather = `${rate[1].replace(',', '.')}x`;

  if (/vanilla/.test(value)) filters.mode = 'vanilla';
  if (/modded|oxide|carbon|kits|tp|teleport|shop|мод/.test(value)) filters.mode = 'modded';
  if (/\bpve\b|зомби|zombies/.test(value)) filters.mode = 'pve';
  if (/official|facepunch/.test(value)) filters.mode = 'official';

  if (/weekly/.test(value)) filters.wipe = 'weekly';
  if (/biweekly|bi-weekly/.test(value)) filters.wipe = 'biweekly';
  if (/monthly/.test(value)) filters.wipe = 'monthly';
  if (/daily/.test(value)) filters.wipe = 'daily';
  if (/wiped today|just wiped|fresh wipe|gerade gewiped|недавний вайп|вайп/.test(value)) {
    filters.sort = 'wipe';
    local.justWiped = true;
  }
  if (/no bp|no blueprint|kein bp|без вайпа чертежей|без bp/.test(value)) {
    filters.bp = 'no';
  }
  if (/high pop|full|voll/.test(value)) filters.population = 'high';
  if (/low pop|empty|leer/.test(value)) filters.population = 'low';
  if (/low ping|ping/.test(value)) filters.lowPing = true;

  return { filters, local };
}

function detectBpWipe(server) {
  const text = `${server.name || ''} ${server.description || ''} ${(server.tags || []).join(' ')}`.toLowerCase();
  if (/no bp|no blueprint|kein bp|без вайпа чертежей|без bp/.test(text)) {
    return { value: 'no', label: (t) => t.no };
  }
  if (/bp wipe|blueprint wipe|full wipe|вайп чертеж/.test(text)) {
    return { value: 'yes', label: (t) => t.yes };
  }
  return { value: 'unknown', label: (t) => t.unknown };
}

function sourceLabel(server, t) {
  if (server.wipeConfidence === 'high' || server.dataQuality >= 90) return t.verified;
  if (server.wipeSource === 'server.tags' || server.tags?.length) return t.officialTag;
  if (server.wipeSource === 'name/description' || server.gatherRateDetected || server.groupLimitDetected) return t.nameDetected;
  if (server.lastWipeDetected) return t.historyEstimated;
  return t.uncertain;
}

function optionLabel(value, t) {
  const map = {
    all: t.all,
    vanilla: t.vanilla,
    modded: t.modded,
    official: t.official,
    pve: t.pve,
    players: t.players,
    fresh: 'Fresh',
    confidence: t.confidence,
    radar: t.ranking,
    verified: t.verified,
    high: t.highPop,
    medium: 'Medium',
    low: 'Low',
    no: t.no,
    yes: t.yes,
    unknown: t.unknown
  };
  return map[value] || value;
}

function formatRelative(value, t) {
  if (!value) return t.unknown;
  const diff = Date.now() - new Date(value).getTime();
  if (diff < 0) return formatDate(value, true);
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} h`;
  const days = Math.floor(hours / 24);
  if (days === 1) return t.today;
  return `${days} d`;
}

function formatDate(value, withYear = false) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: withYear ? '2-digit' : undefined,
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}

function percentage(players, maxPlayers) {
  if (!maxPlayers) return 0;
  return Math.max(0, Math.min(100, Math.round(((players || 0) / maxPlayers) * 100)));
}

function formatNumber(value) {
  return new Intl.NumberFormat('de-DE').format(value || 0);
}

function dateValue(value) {
  return value ? new Date(value).getTime() || 0 : 0;
}

function readJson(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch {
    return fallback;
  }
}

function detectLanguage() {
  const code = navigator.language?.slice(0, 2).toLowerCase();
  return LANGS.includes(code) ? code : 'de';
}

export default App;
